import { render } from "./LimitLength.vue?vue&type=template&id=51f0412f"
import script from "./LimitLength.vue?vue&type=script&lang=ts"
export * from "./LimitLength.vue?vue&type=script&lang=ts"
script.render = render

export default script